import MarkAsCompleteTask from '../../common/tasks/MarkAsCompleteTask';
import { TCommonTaskProp } from '../../types';

export const UpdateDataTask = ({
  task,
  context,
  isTimelineView,
  displayNumber,
}: TCommonTaskProp) => {
  return (
    <MarkAsCompleteTask
      task={task}
      context={context}
      isTimelineView={isTimelineView}
      displayNumber={displayNumber}
    />
  );
};
